import React from "react";
import { useI18n } from "../i18n/LanguageContext";

// 7-day money-back seal. Pure SVG so every language renders its own text.
const TEXT = {
  pt: { top: "COMPRA GARANTIDA", bottom: "100% SEGURO", n: "7", unit: "Dias", note: "Reembolso integral em até 7 dias" },
  "pt-PT": { top: "COMPRA GARANTIDA", bottom: "100% SEGURO", n: "7", unit: "Dias", note: "Reembolso integral até 7 dias" },
  en: { top: "GUARANTEED PURCHASE", bottom: "100% SECURE", n: "7", unit: "Days", note: "Full refund within 7 days" },
  es: { top: "COMPRA GARANTIZADA", bottom: "100% SEGURO", n: "7", unit: "Días", note: "Reembolso total en 7 días" },
  fr: { top: "ACHAT GARANTI", bottom: "100% SÉCURISÉ", n: "7", unit: "Jours", note: "Remboursement intégral sous 7 jours" },
  it: { top: "ACQUISTO GARANTITO", bottom: "100% SICURO", n: "7", unit: "Giorni", note: "Rimborso totale entro 7 giorni" },
};

const scallop = (cx, cy, rOut, rIn, teeth) => {
  const pts = [];
  for (let i = 0; i < teeth * 2; i++) {
    const a = (Math.PI * i) / teeth - Math.PI / 2;
    const r = i % 2 === 0 ? rOut : rIn;
    pts.push(`${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)}`);
  }
  return `M${pts.join("L")}Z`;
};

export function GuaranteeSeal({ size = 150, showNote = true, className = "", testid = "guarantee-seal" }) {
  const { lang } = useI18n();
  const T = TEXT[lang] || TEXT.pt;
  const topLen = T.top.length;
  const fsTop = topLen > 18 ? 12.5 : topLen > 15 ? 14 : 15;
  return (
    <div className={`inline-flex flex-col items-center ${className}`} data-testid={testid} data-lang={lang}>
      <svg width={size} height={size * 1.22} viewBox="0 0 200 244" role="img" aria-label={`${T.top} - ${T.n} ${T.unit} - ${T.bottom}`}>
        <defs>
          <linearGradient id="gs-gold" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#f3d27a" /><stop offset="0.5" stopColor="#d4a53a" /><stop offset="1" stopColor="#b8871f" />
          </linearGradient>
          <linearGradient id="gs-ribbon" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#c99a2e" /><stop offset="1" stopColor="#e0b64a" />
          </linearGradient>
          <path id="gs-arc-top" d="M 40 100 A 60 60 0 0 1 160 100" />
          <path id="gs-arc-bottom" d="M 34 100 A 66 66 0 0 0 166 100" />
          <filter id="gs-shadow" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="#000" floodOpacity="0.35" /></filter>
        </defs>
        <g filter="url(#gs-shadow)">
          <path d="M72 168 L60 236 L86 222 L104 240 L110 176 Z" fill="url(#gs-ribbon)" />
          <path d="M128 168 L140 236 L114 222 L96 240 L90 176 Z" fill="url(#gs-ribbon)" />
          <path d={scallop(100, 100, 96, 88, 28)} fill="url(#gs-gold)" />
        </g>
        <circle cx="100" cy="100" r="78" fill="#fff" />
        <circle cx="100" cy="100" r="46" fill="none" stroke="#e5c56a" strokeWidth="2" />
        <text fontFamily="Inter, Arial, sans-serif" fontWeight="800" fontSize={fsTop} fill="#2b2b2b" letterSpacing="1">
          <textPath href="#gs-arc-top" startOffset="50%" textAnchor="middle">{T.top}</textPath>
        </text>
        <text fontFamily="Inter, Arial, sans-serif" fontWeight="800" fontSize="15" fill="#2b2b2b" letterSpacing="1">
          <textPath href="#gs-arc-bottom" startOffset="50%" textAnchor="middle">{T.bottom}</textPath>
        </text>
        <text x="40" y="106" fontSize="13" fill="#d4a53a" textAnchor="middle">★</text>
        <text x="160" y="106" fontSize="13" fill="#d4a53a" textAnchor="middle">★</text>
        <text x="100" y="98" fontFamily="Inter, Arial, sans-serif" fontWeight="900" fontSize="44" fill="#1f1f1f" textAnchor="middle">{T.n}</text>
        <text x="100" y="124" fontFamily="Inter, Arial, sans-serif" fontWeight="600" fontSize="19" fill="#2b2b2b" textAnchor="middle">{T.unit}</text>
      </svg>
      {showNote && <p className="mt-1 text-[11px] text-xmas-champagne/90" data-testid={`${testid}-note`}>{T.note}</p>}
    </div>
  );
}

export default GuaranteeSeal;
